import { Button, ButtonGroup, makeStyles } from "@material-ui/core";
import { FC } from "react";
import { useListContext } from "react-admin";

export interface FilterTab {
  label: string;
  isActive: (filterValues: Record<string, any>) => boolean;
  getFilters: () => Record<string, any>;
}

interface FilterTabsProps {
  tabs: FilterTab[];
  clearKeys?: string[];
}

const useStyles = makeStyles(() => ({
  tabGroup: {
    "& .MuiButton-contained": {
      marginLeft: "0 !important",
    },
  },
  activeTab: {
    backgroundColor: "rgba(0, 0, 0, 0.08) !important",
    "&:hover": {
      backgroundColor: "rgba(0, 0, 0, 0.12) !important",
    },
  },
}));

const FilterTabs: FC<FilterTabsProps> = ({ tabs, clearKeys = [] }) => {
  const classes = useStyles();
  const { filterValues, setFilters } = useListContext();

  const activeTab = tabs.find((t) => t.isActive(filterValues));

  return (
    <ButtonGroup size="small" variant="outlined" className={classes.tabGroup}>
      {tabs.map((tab) => {
        const isActive = activeTab?.label === tab.label;
        return (
          <Button
            key={tab.label}
            className={isActive ? classes.activeTab : ""}
            disableElevation
            onClick={() => {
              const newFilters = { ...filterValues };
              clearKeys.forEach((k) => delete newFilters[k]);
              if (!isActive) {
                Object.assign(newFilters, tab.getFilters());
              }
              setFilters(newFilters, undefined);
            }}
          >
            {tab.label}
          </Button>
        );
      })}
    </ButtonGroup>
  );
};

export default FilterTabs;
